'use client';
import type { FC } from 'react';
import React, { useCallback, useRef } from 'react';
import { useHover } from 'ahooks';
import { DeleteOutlined } from '@ant-design/icons';
import InputVarTypeIcon from '../../_base/components/input-var-type-icon';
import type { MoreInfo } from '../../../types';
import { InputVarType } from '../../../types';
import { type CrudDataType, CrudEnumType } from '../types';
import { Select, Tag } from 'antd';
import crudIconMap from '../config'


const {  Option } = Select;

type Props = {
  readonly: boolean;
  payload: CrudDataType;
  onChange?: (item: CrudDataType, moreInfo?: MoreInfo) => void;
  onRemove?: () => void;
  rightContent?: React.JSX.Element;
  showLegacyBadge?: boolean;
  existCruds: string[];
};

const crudTypeOptions = [
  {
    label: "创建",
    value: CrudEnumType.create,
    icon: crudIconMap.create,
  },
  {
    label: "读取",
    value: CrudEnumType.read,
    icon: crudIconMap.read,
  },
  {
    label: "更新",
    value: CrudEnumType.update,
    icon: crudIconMap.update,
  },
  {
    label: "删除",
    value: CrudEnumType.delete,
    icon: crudIconMap.delete,
  },
];

// const crudTypeOptions = Object.values(CrudEnumType).map(v => {
//   const [value, label] = v.split(',');
//   return { label, value };
// });

const tagRender = (props) => {
  const { label, value, closable, onClose } = props;
  const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };
  return (
    <Tag
      color={'cyan'}
      onMouseDown={onPreventMouseDown}
      closable={closable}
      onClose={onClose}
      style={{ marginRight: 3 }}
    >
      {label}
    </Tag>
  );
};
const CrudData: FC<Props> = ({
  readonly,
  payload,
  onChange = () => {},
  onRemove = () => {},
  rightContent,
  existCruds
}) => {
  const ref = useRef(null);
  const isHovering = useHover(ref);

  const handlePayloadChange = useCallback(
    (payload: CrudDataType, moreInfo?: MoreInfo) => {
      onChange(payload, moreInfo);
    },
    [onChange],
  );
  return (
    <div
      ref={ref}
      className="flex min-h-8 cursor-pointer items-center justify-between rounded-lg border border-gray-200 bg-white pr-2.5 shadow-xs hover:shadow-md"
    >
      <div className="w-24 items-center border-r-2 border-gray-200">
        <Select
          onChange={(e) =>
            handlePayloadChange({ ...payload, type: e })
          }
          className="shrink-0 text-[13px] font-medium text-gray-700"
          placeholder="操作方式"
          bordered={false}
          value={payload.type}
        >
          {
            crudTypeOptions.map(item => {
              return <Option key={item.value} value={item.value}><span className='inline-block w-4 h-full mr-2 relative top-[2px]'>{item.icon}</span>{item.label}</Option>
            })
          }
        </Select>
      </div>
      <div className="flex w-0 grow items-center space-x-1">
        <Select
          mode='tags'
          className="shrink-0 text-[13px] font-medium text-gray-700 w-full"
          value={payload.data}
          placeholder="数据输入/选择"
          bordered={false}
          tagRender={tagRender}
          onChange={(value) => {
            if(payload.type !== 'read') {
              const lastValue = value.pop()
              handlePayloadChange({ ...payload, data: lastValue ? [lastValue] : undefined })
            }else {
              handlePayloadChange({ ...payload, data: value })
            }
          }}
          options={existCruds.map(item => ({ label: item, value: item }))}
        />
      </div>
      <div className="ml-2 flex shrink-0 items-center">
        {rightContent || (
          <>
            {!isHovering || readonly ? (
              <InputVarTypeIcon
                type={InputVarType.textInput}
                className="h-3.5 w-3.5 text-gray-500"
              />
            ) : (
              !readonly && (
                <div
                  onClick={onRemove}
                  className="cursor-pointer rounded-md hover:bg-black/5"
                >
                  <div className="h-3.5 w-3.5 text-center text-gray-500">
                    <DeleteOutlined style={{ verticalAlign: 'text-top' }} />
                  </div>
                </div>
              )
            )}
          </>
        )}
      </div>
    </div>
  );
};
export default React.memo(CrudData);
